module.exports = __webpack_public_path__ + "static/media/laser_LENS_pink.8218f77d.png";